import { combineReducers, configureStore } from "@reduxjs/toolkit";
import TestReducer from "./slices/test";

const rootReducer = combineReducers({
  test: TestReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
